import { render, staticRenderFns } from "./logonstart.vue?vue&type=template&id=30dedede&scoped=true"
import script from "./logonstart.vue?vue&type=script&lang=js"
export * from "./logonstart.vue?vue&type=script&lang=js"
import style0 from "./logonstart.vue?vue&type=style&index=0&id=30dedede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dedede",
  null
  
)

export default component.exports